export default __webpack_public_path__ + "static/media/12790.4003bb13.png";